export const permissionAdminObject = {
  dashboard: {
    type: "single",
    options: {
      "allow-view": true,
    },
  },
  "live-monitor": {
    type: "single",
    options: {
      "allow-view": true,
    },
  },
  dialpad: {
    type: "single",
    options: {
      "allow-view": true,
    },
  },
  chatscreen: {
    type: "parent",
    children: ["sms", "email", "rcs", "whatsapp", "nlp-config"],
  },
  sms: {
    type: "sub-parent",
    parent: "chatscreen",
    children: [
      "sms-dashboard",
      "sms-template",
      "sms-provider",
      "smpp-provider",
      "sms-sender",
      "sms-report",
    ],
  },
  "sms-dashboard": {
    type: "accordion-child",
    label: "dashboard",
    parent: "sms",
    options: {
      "allow-view": true,
    },
  },
  "sms-template": {
    type: "accordion-child",
    parent: "sms",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  "sms-provider": {
    type: "accordion-child",
    parent: "sms",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  "smpp-provider": {
    type: "accordion-child",
    parent: "sms",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  "sms-sender": {
    type: "accordion-child",
    parent: "sms",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  "sms-report": {
    type: "accordion-child",
    parent: "sms",
    label: "cdrs",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  email: {
    type: "sub-parent",
    parent: "chatscreen",
    children: ["email-template", "email-provider", "email-report"],
  },
  "email-template": {
    type: "accordion-child",
    parent: "email",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  "email-provider": {
    type: "accordion-child",
    parent: "email",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  "email-report": {
    type: "accordion-child",
    parent: "email",
    label: "cdrs",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  rcs: {
    type: "sub-parent",
    parent: "chatscreen",
    children: ["rcs-dashboard", "rcs-provider", "rcs-report"],
  },
  "rcs-dashboard": {
    type: "accordion-child",
    label: "dashboard",
    parent: "rcs",
    options: {
      "allow-view": true,
    },
  },
  "rcs-provider": {
    type: "accordion-child",
    parent: "rcs",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  "rcs-report": {
    type: "accordion-child",
    parent: "rcs",
    label: "cdrs",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  whatsapp: {
    type: "sub-parent",
    parent: "chatscreen",
    children: [
      "whatsapp-dashboard",
      "whatsapp-provider",
      "whatsapp-template",
      "whatsapp-report",
      "whatsapp-number",
    ],
  },
  "whatsapp-dashboard": {
    type: "accordion-child",
    label: "dashboard",
    parent: "whatsapp",
    options: {
      "allow-view": true,
    },
  },
  "whatsapp-provider": {
    type: "accordion-child",
    parent: "whatsapp",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  "whatsapp-template": {
    type: "accordion-child",
    parent: "whatsapp",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  "whatsapp-report": {
    type: "accordion-child",
    parent: "whatsapp",
    label: "cdrs",
    options: {
      all: true,
      list: true,
      export: true,
      delete: true,
    },
  },
  "whatsapp-number": {
    type: "accordion-child",
    parent: "whatsapp",
    label: "cdrs",
    options: {
      all: true,
      list: true,
      export: true,
      delete: true,
    },
  },
  "nlp-config": {
    type: "sub-parent",
    parent: "chatscreen",
    children: ["nlp-dashboard", "nlp-agent"],
  },
  "nlp-dashboard": {
    type: "accordion-child",
    label: "dashboard",
    parent: "nlp-config",
    options: {
      "allow-view": true,
    },
  },
  "nlp-agent": {
    type: "accordion-child",
    parent: "nlp-config",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
      "train-agent": true,
    },
  },
  reports: {
    type: "parent",
    children: ["global", "message", "agent", "lead", "obd", "cpass", "log"],
  },
  global: {
    type: "sub-parent",
    parent: "reports",
    children: [
      "voice-cdr-report",
      "outbound-cdr-report",
      "inbound-cdr-report",
      "dnc-cdr-report",
      "call-report",
    ],
  },
  "voice-cdr-report": {
    type: "accordion-child",
    parent: "global",
    options: {
      all: true,
      list: true,
      "recording-access": true,
      "recording-download": true,
      download: true,
    },
  },
  "outbound-cdr-report": {
    type: "accordion-child",
    parent: "global",
    options: {
      all: true,
      list: true,
      "recording-access": true,
      "recording-download": true,
      download: true,
    },
  },
  "inbound-cdr-report": {
    type: "accordion-child",
    parent: "global",
    options: {
      all: true,
      list: true,
      "recording-access": true,
      "recording-download": true,
      download: true,
    },
  },
  "dnc-cdr-report": {
    type: "accordion-child",
    parent: "global",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  "call-report": {
    type: "accordion-child",
    parent: "global",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  message: {
    type: "sub-parent",
    parent: "reports",
    children: [
      "message-cdr-report",
    ],
  },
  "message-cdr-report": {
    type: "accordion-child",
    parent: "message",
    options: {
      all: true,
      list: true,
      "recording-access": true,
      "recording-download": true,
      download: true,
    },
  },
  agent: {
    type: "sub-parent",
    parent: "reports",
    children: [
      "agent-outbound-cdr-report",
      "agent-inbound-cdr-report",
      "agent-outbound-drop-report",
      "agent-inbound-missed-report",
      "user-summary-report",
      "break-summary-report",
      "dispose-summary-report",
      "callback-report",
      "team-summary-report",
      "campaign-summary-report",
      "auto-dispose-summary-report",
    ],
  },
  "agent-outbound-cdr-report": {
    type: "accordion-child",
    parent: "agent",
    options: {
      all: true,
      list: true,
      "recording-access": true,
      "recording-download": true,
      download: true,
    },
  },
  "agent-inbound-cdr-report": {
    type: "accordion-child",
    parent: "agent",
    options: {
      all: true,
      list: true,
      "recording-access": true,
      "recording-download": true,
      download: true,
    },
  },
  "agent-outbound-drop-report": {
    type: "accordion-child",
    parent: "agent",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  "agent-inbound-missed-report": {
    type: "accordion-child",
    parent: "agent",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  "user-summary-report": {
    type: "accordion-child",
    parent: "agent",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  "break-summary-report": {
    type: "accordion-child",
    parent: "agent",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  "dispose-summary-report": {
    type: "accordion-child",
    parent: "agent",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  "callback-report": {
    type: "accordion-child",
    parent: "agent",
    label: "call back",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  "team-summary-report": {
    type: "accordion-child",
    parent: "agent",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  "campaign-summary-report": {
    type: "accordion-child",
    parent: "agent",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  "auto-dispose-summary-report": {
    type: "accordion-child",
    parent: "agent",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  lead: {
    type: "sub-parent",
    parent: "reports",
    children: [
      "contact-list-call-statistics-report",
      "lead-status-report",
      "duplicate-lead-identification-report",
      "contact-list-quality-assurance-report",
    ],
  },
  "contact-list-call-statistics-report": {
    type: "accordion-child",
    parent: "lead",
    options: {
      all: false,
      list: false,
      download: false,
    },
  },
  "lead-status-report": {
    type: "accordion-child",
    parent: "lead",
    options: {
      all: false,
      list: false,
      download: false,
    },
  },
  "contact-list-quality-assurance-report": {
    type: "accordion-child",
    parent: "lead",
    options: {
      all: false,
      list: false,
      download: false,
    },
  },
  "duplicate-lead-identification-report": {
    type: "accordion-child",
    parent: "lead",
    options: {
      all: false,
      list: false,
      download: false,
    },
  },
  obd: {
    type: "sub-parent",
    parent: "reports",
    children: ["broadcast-cdr-report"],
  },
  "broadcast-cdr-report": {
    type: "accordion-child",
    parent: "agent",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  cpass: {
    type: "sub-parent",
    parent: "reports",
    children: ["cpass-outbound-cdr-report", "cpass-inbound-cdr-report"],
  },
  "cpass-outbound-cdr-report": {
    type: "accordion-child",
    parent: "cpass",
    options: {
      all: true,
      list: true,
      download: true,
      "recording-access": true,
      "recording-download": true,
    },
  },
  "cpass-inbound-cdr-report": {
    type: "accordion-child",
    parent: "cpass",
    options: {
      all: true,
      list: true,
      download: true,
      "recording-access": true,
      "recording-download": true,
    },
  },
  log: {
    type: "sub-parent",
    parent: "reports",
    children: ["webhook-report"],
  },
  "webhook-report": {
    type: "accordion-child",
    parent: "log",
    options: {
      all: true,
      list: true,
      download: true,
    },
  },
  team: {
    type: "parent",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
      "manage-agent": true,
      "manage-team-leader": true,
    },
  },
  campaigns: {
    active: true,
    type: "parent",
    children: ["campaign-voice", "campaign-message"],
    options: {
      all: true,
      add: true,
      list: true,
      edit: true,
      delete: true,
      "churn-contact": true,
      "manage-contact-list": true,
      "calling-status": true,
    },
  },
  "campaign-voice": {
    type: "accordion-child",
    parent: "campaigns",
    label: "voice",
    options: {
      preview: true,
      auto: true,
      broadcast: true,
    },
  },
  "campaign-message": {
    type: "accordion-child",
    parent: "campaigns",
    label: "message",
    options: {
      whatsapp: true,
      rcs: true,
      sms: true,
    },
  },
  settings: {
    type: "parent",
    children: [
      "users-and-permissions",
      "communication-channels",
      "general-settings",
      "account-setting",
    ],
  },
  "users-and-permissions": {
    type: "sub-parent",
    parent: "settings",
    children: ["user", "skill", "permission"],
  },
  user: {
    type: "sub-parent",
    parent: "users-and-permissions",
    children: ["skill-mapping"],
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
      import: true,
      "sip-info": true,
    },
  },
  "skill-mapping": {
    type: "sub-parent",
    parent: "users",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
    },
  },
  skill: {
    type: "sub-parent",
    parent: "users-and-permission",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
      import: true,
    },
  },
  permission: {
    type: "sub-parent",
    parent: "users-and-permission",
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
      import: true,
    },
  },
  "communication-channels": {
    type: "sub-parent",
    parent: "settings",
    children: [
      "provider",
      "phone-number",
      "integration",
      "missed-call-to-campaign",
    ],
  },
  "missed-call-to-campaign": {
    type: "accordion-child",
    parent: "communication-channels",
    options: {
      all: true,
      list: true,
      edit: true,
      add: true,
      delete: true,
    },
  },
  "phone-number": {
    type: "accordion-child",
    parent: "communication-channels",
    options: {
      all: true,
      list: true,
      edit: true,
      add: true,
      delete: true,
      import: true,
      "default-phone-number": true,
    },
  },
  provider: {
    type: "sub-parent",
    parent: "communication-channels",
    children: ["carrier-rate"],
    options: {
      all: true,
      list: true,
      add: true,
      edit: true,
      delete: true,
    },
  },
  "carrier-rate": {
    type: "sub-parent",
    parent: "provider",
    options: {
      all: true,
      list: true,
      edit: true,
      add: true,
      delete: true,
      import: true,
    },
  },
  integration: {
    type: "sub-parent",
    label: "app integration",
    parent: "communication-channels",
    children: [
      "leadsquared-integration",
      "salesforce-integration",
      "zoho-crm-integration",
      "webhook-integration",
      "popup-integration",
      "guidewire-integration",
    ],
    options: {
      status: true,
      configure: true,
      "allow-view": true,
    },
  },
  "leadsquared-integration": {
    type: "accordion-child",
    parent: "integration",
    options: {
      all: true,
      list: true,
      edit: true,
    },
  },
  "salesforce-integration": {
    type: "accordion-child",
    parent: "integration",
    options: {
      all: true,
      add: true,
      list: true,
      edit: true,
      delete: true,
    },
  },
  "zoho-crm-integration": {
    type: "accordion-child",
    parent: "integration",
    options: {
      all: true,
      add: true,
      list: true,
      edit: true,
      delete: true,
    },
  },
  "webhook-integration": {
    type: "accordion-child",
    parent: "integration",
    options: {
      all: true,
      add: true,
      list: true,
      edit: true,
      delete: true,
    },
  },
  "popup-integration": {
    type: "accordion-child",
    parent: "integration",
    options: {
      all: true,
      add: true,
      list: true,
      edit: true,
      delete: true,
    },
  },
  "guidewire-integration": {
    type: "accordion-child",
    parent: "integration",
    options: {
      all: true,
      add: true,
      list: true,
      edit: true,
      delete: true,
    },
  },
  "general-settings": {
    type: "sub-parent",
    parent: "settings",
    children: [
      "disposition",
      "contact",
      "sound",
      "break",
      "dnc",
      "holiday",
      "flow",
      "import-export",
      "logs",
    ],
  },
  disposition: {
    type: "accordion-child",
    parent: "general-settings",
    options: {
      all: true,
      list: true,
      edit: true,
      add: true,
      delete: true,
      import: true,
    },
  },
  contact: {
    type: "accordion-child",
    parent: "general-settings",
    options: {
      all: true,
      list: true,
      edit: true,
      add: true,
      delete: true,
      import: true,
      download: true,
    },
  },
  sound: {
    type: "accordion-child",
    parent: "general-settings",
    options: {
      all: true,
      list: true,
      edit: true,
      add: true,
      delete: true,
    },
  },
  break: {
    type: "accordion-child",
    parent: "general-settings",
    options: {
      all: true,
      list: true,
      edit: true,
      add: true,
      delete: true,
      import: true,
    },
  },
  dnc: {
    type: "accordion-child",
    label: "dnc",
    parent: "general-settings",
    options: {
      all: true,
      list: true,
      edit: true,
      add: true,
      delete: true,
      import: true,
    },
  },
  holiday: {
    type: "accordion-child",
    parent: "general-settings",
    options: {
      all: true,
      list: true,
      edit: true,
      add: true,
      delete: true,
      import: true,
    },
  },
  flow: {
    type: "accordion-child",
    parent: "general-settings",
    options: {
      all: true,
      list: true,
      edit: true,
      add: true,
      delete: true,
    },
  },
  "import-export": {
    type: "accordion-child",
    parent: "general-settings",
    options: {
      list: true,
      download: true,
    },
  },
  logs: {
    type: "accordion-child",
    label: "logs",
    parent: "general-settings",
    options: {
      list: true,
    },
  },
  "account-setting": {
    type: "sub-parent",
    parent: "settings",
    children: ["account", "security", "plans-and-billing"],
  },
  account: {
    type: "accordion-child",
    parent: "account-setting",
    options: {
      all: true,
      list: true,
      edit: true,
      delete: true,
    },
  },
  security: {
    type: "sub-parent",
    parent: "account-setting",
    children: ["token-access"],
    options: {
      all: false,
      view: false,
      "change-password": false,
      update: false,
    },
  },
  "token-access": {
    type: "sub-parent",
    parent: "security",
    options: {
      add: false,
      list: false,
      delete: false,
    },
  },
  "plans-and-billing": {
    type: "accordion-child",
    parent: "account-setting",
    options: {
      all: true,
      list: true,
      edit: true,
      add: true,
      delete: true,
    },
  },
  notification: {
    type: "accordion-child",
    parent: "account-setting",
    options: {
      all: false,
      view: false,
      edit: false,
    },
  },
};



// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CommonPermission/PermissionAdminObject.js